exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.modal-header[data-v-06a33e6b] {\r\n  background-color: var(--primary);\n}\n.modal-title[data-v-06a33e6b] {\r\n  color: #fff;\n}\n.close[data-v-06a33e6b] {\r\n  color: #fff;\r\n  opacity: 1;\n}\nlegend[data-v-06a33e6b] {\r\n  padding: 10px 0;\r\n  margin: 10px 0 0;\n}\n.list-group-item[data-v-06a33e6b] {\r\n  padding: 10px !important;\r\n  border: none;\n}\n.btn-primary[data-v-06a33e6b] {\r\n  color: #fff;\r\n  background-color: var(--primary);\r\n  border-color: var(--primary);\n}\n.btn-primary[data-v-06a33e6b]:focus,\r\n.btn-primary[data-v-06a33e6b]:hover {\r\n  background-color: #204d74;\r\n  border-color: #122b40;\n}\r\n", ""]);

// exports
